import './utils/nonce';
import {hydrateRoot} from 'react-dom/client';
import {BrowserRouter as Router} from 'react-router-dom';
import {loadableReady} from '@loadable/component';
import {Provider} from 'react-redux';
import useInitializeGraphicalSignature from '@components/SignerUi/hooks/useInitializeGraphicalSignature';
import getStore from './setup/store';
import NotificationsHub from './components/shared/NotificationsHub/NotificationsHub';
import App from './components/App';
import {setReduxStoreToHttpClient} from './utils/httpClient';
import '@formatjs/intl-pluralrules/polyfill';
import '@formatjs/intl-pluralrules/locale-data/en';
import '@formatjs/intl-getcanonicallocales/polyfill';
import {BASE_PATH} from '../constants';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/500.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import '@fontsource/league-spartan/400.css';
import '@fontsource/league-spartan/600.css';
import '@fontsource/league-spartan/700.css';

const store = getStore();

setReduxStoreToHttpClient(store);

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
export type AppStore = typeof store

const Client = () => {
    useInitializeGraphicalSignature();
    return (
        <Provider store={store} key="provider">
            <Router basename={BASE_PATH}>
                <NotificationsHub />
                <App />
            </Router>
        </Provider>
    );
};

window.onload = () => {
    import('./components/shared/Documents/utils').then(({initPDFJS}) => {
        initPDFJS();
    });

    import('./components/shared/Documents/pageDebugOverlayState').then(({setPageDebugOverlayControls}) => {
        setPageDebugOverlayControls();
    });

    loadableReady(() => {
        hydrateRoot(
            document.getElementById('app'),
            <Client />
        );
    });
};
